import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Button, Checkbox } from 'antd';

//redux
import { connect } from 'react-redux';
import { UpdateMerchantRecords } from 'store/actions/adminActions';
import { toast } from 'react-toastify';

const ExcludeMerchantModal = (props) => {
    const { open, handleClose, merchant, UpdateMerchantRecords } = props;
    const [exclude_background_check, setExclude_background_check] = useState(false);
    const [loading, setLoading] = useState(false);

    const closeAll = () => {
        setExclude_background_check(false);
        handleClose();
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await UpdateMerchantRecords(merchant?.id, {
            exclude_background_check,
        });
        setLoading(false);
        if (res?.success) {
            toast.success(res?.message);
            closeAll();
        } else {
            toast.error(res?.message);
        }
    };
    useEffect(() => {
        setExclude_background_check(merchant?.exclude_background_check);
    }, [merchant, open]);
    return (
        <Modal title={'Exclude Merchant'} open={open} onCancel={closeAll} footer={null} destroyOnClose={true}>
            <form onSubmit={handleSubmit}>
                <Row justify="end">
                    <Col span={24} className="my-2">
                        <Checkbox
                            name="exclude_background_check"
                            onChange={(event) => setExclude_background_check(event.target.checked)}
                            className="ml-0 mr-2 mb-1"
                            checked={exclude_background_check}
                        >
                            Exclude background check for organization
                        </Checkbox>
                    </Col>
                </Row>
                <Row justify="end" className="mt-3">
                    <Col>
                        <Button className="ant-btn" htmlType="submit" type="primary" loading={loading}>
                            Submit
                        </Button>
                    </Col>
                </Row>
            </form>
        </Modal>
    );
};

const mapStateToProps = (state) => {
    return {
        ...state,
    };
};
export default connect(mapStateToProps, { UpdateMerchantRecords })(ExcludeMerchantModal);
